/* eslint-disable no-use-before-define */

/* eslint-disable no-unused-vars */

/* eslint-disable @typescript-eslint/no-unused-vars */
import React from "react";
import {
  Animated,
  StyleProp,
  ViewStyle,
  TextStyle,
} from "react-native";
import SVG_Svg, {
  G as SVG_G,
  Path as SVG_Path,
  GProps,
  PathProps,
} from "react-native-svg";
/* SVGR has dropped some elements not supported by react-native-svg: desc */

/***/

const Path = Animated.createAnimatedComponent<
  React.ComponentClass<
    PathProps & {
      style?: StyleProp<ViewStyle>;
    }
  >
>(SVG_Path);
const G = Animated.createAnimatedComponent<
  React.ComponentClass<
    GProps & {
      style?: StyleProp<ViewStyle>;
    }
  >
>(SVG_G);
const Svg = Animated.createAnimatedComponent(SVG_Svg);

/*
 * -------------------------------------------------------------------------
 *
 *  /$$$$$$                                /$$$$$$$  /$$
 * |_  $$_/                               | $$__  $$| $$
 *   | $$   /$$$$$$/$$$$   /$$$$$$        | $$  \ $$| $$ /$$   /$$  /$$$$$$
 *   | $$  | $$_  $$_  $$ /$$__  $$       | $$$$$$$ | $$| $$  | $$ /$$__  $$
 *   | $$  | $$ \ $$ \ $$| $$  \ $$       | $$__  $$| $$| $$  | $$| $$$$$$$$
 *   | $$  | $$ | $$ | $$| $$  | $$       | $$  \ $$| $$| $$  | $$| $$_____/
 *  /$$$$$$| $$ | $$ | $$| $$$$$$$/  /$$  | $$$$$$$/| $$|  $$$$$$/|  $$$$$$$
 * |______/|__/ |__/ |__/| $$____/  |__/  |_______/ |__/ \______/  \_______/
 *                       | $$
 *                       | $$
 *                       |__/
 *
 * -------------------------------------------------------------------------
 *
 * ORIGINAL SVG
 * ---------------------------------
 * <svg width="24" height="26" viewBox="0 0 24 26" fill="none" xmlns="http://www.w3.org/2000/svg"> <desc id="IMP.BLUE"></desc>
 * <g id="StorefrontIcon">
 * <path id="Vector" d="M23.303 25.8922H0L2.31583 5.75378H20.9872L23.303 25.8922ZM1.59213 24.4537H21.7109L19.6845 7.19224H3.61848L1.59213 24.4537Z" fill="black"/>
 * <path id="Vector_2" d="M17.5135 6.47306H16.0661V5.89768C16.0661 3.4523 14.1845 1.43846 11.7239 1.43846C9.26333 1.43846 7.38172 3.4523 7.38172 5.89768V6.47306H5.93433V5.89768C5.93433 2.73307 8.53963 0 11.7239 0C14.9082 0 17.5135 2.58923 17.5135 5.89768V6.47306Z" fill="black"/>
 * </g>
 * </svg>
 *
 * ---------------------------------
 *
 * CONFIGURATION
 * ---------------------------------
 * {}
 * ---------------------------------
 *
 * DESCRIPTION
 * ---------------------------------
 * No description provided!
 * ---------------------------------
 */

/** Component Properties Interface */
export type tProps = {
  style?: tStyle;
  svgStyle?: tStyle;
  isInsideScrollView?: boolean;
  svgRef?: () => void;
  onAnimationComplete?: () => void;
};
/***/

/***/

export type tStyle = StyleProp<ViewStyle>;
export type tTextStyle = StyleProp<TextStyle>;
/***/

/***/

/**
 * Auto-Generated Imp.Blue Component based on your design!
 * @param {tProps} props Developer interface to the component!
 * @returns {JSX.Element} JSX
 *
 * Description --
 * No description provided!
 */

export const StorefrontIcon = (props: {
  style?: tStyle;
  svgStyle?: tStyle;
  isInsideScrollView?: boolean;
  svgRef?: () => void;
  onAnimationComplete?: () => void;
}): JSX.Element => {
  const {
    svgRef,
  } = props;
  /** End Custom React-Hooks */

  /** Component Render (Javascript-React Markup) */

  return (
    <Svg viewBox="0 0 24 26" fill="none" id="svg_root" ref={svgRef} {...props}>
      <G id="StorefrontIcon">
        <Path
          id="Vector"
          d="M23.303 25.8922H0L2.31583 5.75378H20.9872L23.303 25.8922ZM1.59213 24.4537H21.7109L19.6845 7.19224H3.61848L1.59213 24.4537Z"
          fill="black"
          strokeWidth="1"
          vectorEffect="non-scaling-stroke"
        />
        <Path
          id="Vector_2"
          d="M17.5135 6.47306H16.0661V5.89768C16.0661 3.4523 14.1845 1.43846 11.7239 1.43846C9.26333 1.43846 7.38172 3.4523 7.38172 5.89768V6.47306H5.93433V5.89768C5.93433 2.73307 8.53963 0 11.7239 0C14.9082 0 17.5135 2.58923 17.5135 5.89768V6.47306Z"
          fill="black"
          strokeWidth="1"
          vectorEffect="non-scaling-stroke"
        />
      </G>
    </Svg>
  );
};
/***/

export default React.memo(StorefrontIcon);
